import { render, staticRenderFns } from "./RiskAnswersView.vue?vue&type=template&id=1eaac252&scoped=true"
import script from "./RiskAnswersView.vue?vue&type=script&lang=js"
export * from "./RiskAnswersView.vue?vue&type=script&lang=js"
import style0 from "./RiskAnswersView.vue?vue&type=style&index=0&id=1eaac252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaac252",
  null
  
)

export default component.exports